import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UsersService } from '../../services/users.service';
import { Invitation } from '../../models/invitation.model';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from "@angular/material/table";
import { MatButtonModule } from "@angular/material/button";
import { MatDividerModule } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-invitation-details',
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatButtonModule,
    MatDividerModule,
    MatIcon
],
  templateUrl: './invitation-details.component.html',
  styleUrl: './invitation-details.component.css'
})
export class InvitationDetailsComponent implements OnInit{

  isLoading: boolean = true;
  invitationId?: number;
  invitation!: Invitation;
  tableElements!: string[]
  

  errorMessage = {
    isError: false,
    message: ''
  }
  constructor(
    private router: Router,
    private usersSerivce: UsersService,
    private route: ActivatedRoute,
  ){}

  ngOnInit(): void {
    this.invitationId = Number(this.route.snapshot.paramMap.get('invitationId'));

    this.fetchInvitation();
  }

  fetchInvitation() {
    this.usersSerivce.getInvitation(this.invitationId!).subscribe({
      next: (res: any) => {
        console.log("Rezultat: ",res);
        
        this.invitation = res.data as Invitation;
        const expires_at = this.invitation.expires_at;
        const created_at = this.invitation.created_at;

        this.invitation.expires_at = this.formatDate(new Date(expires_at))
        this.invitation.created_at = this.formatDate(new Date(created_at))

        this.isLoading=false;
      },
      error: (err) => {
        if(err.status === 401) {
          this.router.navigate(['/']);
        }
        this.errorMessage.isError = true;
        this.errorMessage.message = err.status;
        console.error(err);
        this.isLoading=false;
      }
    })
  }

  formatDate(date:Date) {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');

        return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
    }
    
    onBack() {
      this.router.navigate(['invitation-list']);
    }
}
